import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useQuery, sendEventTracking } from "../../utils/GeneralUtils";

type WrappedProps = {
  currentPage: number;
  perView: number;
  keyword: string;
  handlePerView: (per: number) => void;
  handleKeyword: (key: string) => void;
  clearSearch: () => void;
  updateQuery: (field: string, value: string | Array<string>) => void;
  getParam: (field: string) => string;
  getParamAll: (field: string) => string[];
  handleSearch: () => void;
};

type Props = {
  wrappedComponent: React.FC<WrappedProps>;
};

const SearchWrapper: React.FC<Props> = ({
  wrappedComponent: WrappedComponent,
}) => {
  const query = useQuery();
  const navigate = useNavigate();
  const location = useLocation();

  const updateQuery = (field: string, value: string | Array<string>) => {
    query.delete(field);

    if (typeof value === "string") {
      if (value.length) query.set(field, value);
    } else {
      value.map((el) => {
        query.append(field, el);
      });
    }
  };

  const handleSearch = () => {
    query.delete("pg");
    navigate({ search: query.toString() });
  };

  const getParam = (field: string) => {
    const param = query.get(field);
    return param !== null ? param : "";
  };

  const getParamAll = (field: string) => {
    return query.getAll(field);
  };

  const handlePerView = (value: number) => {
    updateQuery("per", value.toString());

    updateQuery("pg", "1");

    sendEventTracking(
      "click",
      `${location.pathname.split("/")[1]}List`,
      value.toString()
    );
    navigate({ search: query.toString() });
  };

  const handleKeyword = (value: string) => {
    updateQuery("s", value);
  };

  const clearSearch = () => {
    navigate({ search: "" });
  };

  const paramToCurrentPage = (param: string | null) => {
    return param ? Number(param) : 1;
  };

  const paramToPerview = (param: string | null) => {
    return param ? Number(param) : 12;
  };

  return (
    <WrappedComponent
      currentPage={paramToCurrentPage(query.get("pg"))}
      perView={paramToPerview(query.get("per"))}
      keyword={getParam("s")}
      handlePerView={handlePerView}
      handleKeyword={handleKeyword}
      clearSearch={clearSearch}
      updateQuery={updateQuery}
      getParam={getParam}
      getParamAll={getParamAll}
      handleSearch={handleSearch}
    />
  );
};

export default SearchWrapper;
